export default __webpack_public_path__ + "static/media/cubicles.a2c27856.png";